import { Injectable, inject } from '@angular/core';
import { CaseAuthorizationState } from '../../states/case-authorization.state';
import { CaseRole } from '../../../domain/enums/case-role.enum';

/**
 * Use case for reading the current user's case role.
 * Returns null if the authorization state has not been loaded yet.
 */
@Injectable({ providedIn: 'root' })
export class GetCaseRoleUseCase {
  private readonly state = inject(CaseAuthorizationState);

  public execute(): CaseRole | null {
    return this.state.role();
  }
}
